import apiClient from "../apiClient";

const resource = "patientsPayments";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getForReceipt: id => apiClient.get(`${resource}/${id}/receipt`),
    getForComplete: id => apiClient.get(`${resource}/${id}/complete`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    complete: (id, payload) => apiClient.put(`${resource}/${id}/complete`, payload),
    cancel: id => apiClient.put(`${resource}/${id}/cancel`),
    
    // add: payload => apiClient.post(`${resource}`, payload),
    // edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload),
    // edit: (id, payload) => apiClient.put(`${resource}/${id}/complete`, payload),
    // lock: id => apiClient.put(`${resource}/${id}/lock`),
    // unlock: id => apiClient.put(`${resource}/${id}/unlock`),
    // delete: id => apiClient.delete(`${resource}/${id}`),

};
